<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="showModal"
      width="700"
      header
      footer
      @ok="() => (showModal = false)"
    >
      <div class="terms-modal-container text-center">
        <div class="context my-5">
          <h3>Thank you for helping us create your profile</h3>
          <p>
            Verifying your account will take upto 4 hours. Verifying your
            account will take upto 4 hours. Verifying your account will take
            upto 4 hours. Verifying your account will take upto 4 hours.
          </p>
          <p>Note: Physician previliges will be accessible after approval.</p>
          <button
            class="dovemed-button primary-button font-white"
            :style="{ background: getPrimaryColor() }"
          >
            CONTINUE
          </button>
        </div>
      </div> 
    </a-modal>
  </div>
</template> 

<script>
export default {
  name: "DoctorProfileTY",
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.terms-modal-container {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/DoctorProfileTY.vue